import React from 'react';
import { Link } from 'react-router';
import ProviderSearchBar from './ProviderSearchBar';
import '../../scss/Provider/ProviderNavbar.scss';
import { HiOutlinePlus } from 'react-icons/hi';
import { Tooltip as ReactTooltip } from "react-tooltip";
import intl from 'components/i18n/ReactIntlWrapper';

const ProviderNavbar = ({ onSearch }) => {
    
    return (
        <nav className='navbar container-fluid'>
            <ProviderSearchBar onSearch={onSearch}/>
            <Link to= '/provider/new'><button className='btn btn-primary p-1 plusButton' type='button' id='newProvider' data-tooltip-id='tooltipButton'><HiOutlinePlus className='plusIcon'/></button></Link>
            <ReactTooltip 
                id='tooltipButton'
                place='left'
                content={intl.get('navbar.newProvider.button')}
            />
        </nav>
    )
}

export default ProviderNavbar;